import { Location } from '@angular/common';
import { Component, Optional } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { PrivacyAndTermsComponent } from '../../shared';

@Component({
    selector: 'app-terms',
    imports: [
        MatDialogModule,
        MatButtonModule,
        PrivacyAndTermsComponent
    ],
    templateUrl: './terms.component.html',
    styleUrl: './terms.component.scss'
})
export class TermsComponent {

  constructor(@Optional() private dialogRef: MatDialogRef<TermsComponent>, private location: Location) { }

  closeDialog(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
    else {
      this.location.back();
    }
  }
}
